import type { MarketProject, ProjectCategory } from './market';

export type Maturity = 1 | 2 | 3 | 4 | 5;

/** 项目工作进展 — 「是否完成」 */
export type CompletionStatus = 'completed' | 'incomplete';

/** 工作管理 — 按项目关联的对接记录（只读台账） */
export interface DockingRecord {
  id: string;
  /** 关联项目库主键（项目编号） */
  projectId: string;
  /** 台账导出时的项目名称快照 */
  projectName: string;
  dockedAt: string;
  /** 台账「填报时间」（对接记录录入日期），可能为空 */
  filedAt: string;
  ourParticipants: string[];
  counterpartyOrg: string;
  counterpartyParticipants: string[];
  summary: string;
  maturity: Maturity | null;
  issues: string;
  followUpPlan: string;
  /** 计划完成时间（YYYY-MM-DD），项目工作进展列 */
  plannedCompletedAt: string;
  /** 是否完成；未填写时为 null */
  completionStatus: CompletionStatus | null;
  /** 已逾期天数；「未逾期」为 0，未填写为 null */
  overdueDays: number | null;
  /** 台账「已逾期天数」原文（如「未逾期」） */
  overdueLabel: string;
  memoFileName: string;
  memoPath: string | null;
}

export interface DockingFilter {
  category: 'all' | ProjectCategory;
  keyword?: string;
  maturity: Maturity | null;
  dateFrom?: string;
  dateTo?: string;
}

export const DEFAULT_DOCKING_FILTER: DockingFilter = {
  category: 'all',
  maturity: null,
};

/** 项目工作进展页筛选 */
export interface ProgressFilter {
  category: 'all' | ProjectCategory;
  keyword?: string;
  /** all = 全部；unspecified = 未填写是否完成 */
  completion: 'all' | CompletionStatus | 'unspecified';
  /** all | overdue | not_overdue | unspecified */
  overdue: 'all' | 'overdue' | 'not_overdue' | 'unspecified';
}

export const DEFAULT_PROGRESS_FILTER: ProgressFilter = {
  category: 'all',
  completion: 'all',
  overdue: 'all',
};

export interface ProgressStatistics {
  total: number;
  completed: number;
  incomplete: number;
  overdue: number;
}

export interface DockingStatistics {
  preliminary: number;
  performance: number;
}

export interface ProjectDockingSummary {
  projectId: string;
  project: MarketProject;
  recordCount: number;
  latestDockedAt: string;
  latestCounterpartyOrg: string;
}
